import Cookies from 'js-cookie';
import { AUTH_COOKIE_PATH, persistQualidocAuthCookies } from '@/lib/auth/auth-cookies';
import { isQualidocJwt } from '@/lib/auth/qualidoc-jwt';
import { AUTH_TOKEN_KEY, EMAIL_VERIFIED } from '@/lib/constants';
export function useToken() {
  return {
    setToken(token: string) {
      persistQualidocAuthCookies({ accessToken: token });
    },
    getToken() {
      return Cookies.get(AUTH_TOKEN_KEY);
    },
    removeToken() {
      Cookies.remove(AUTH_TOKEN_KEY, { path: AUTH_COOKIE_PATH });
    },
    hasToken() {
      return isQualidocJwt(Cookies.get(AUTH_TOKEN_KEY));
    },
    setEmailVerified(emailVerified: boolean | null) {
      Cookies.set(EMAIL_VERIFIED, JSON.stringify({ emailVerified }));
    },
    getEmailVerified() {
      const emailVerified = Cookies.get(EMAIL_VERIFIED);
      return emailVerified ? JSON.parse(emailVerified) : true;
    },
  };
}
